var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 314,
    viewBox: "0 0 512 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.11 313.094C251.377 313.094 249.759 312.632 248.256 311.823L232.885 302.693C230.573 301.421 231.729 300.959 232.423 300.728C235.543 299.688 236.121 299.456 239.357 297.608C239.704 297.376 240.167 297.492 240.513 297.723L252.302 304.773C252.764 305.004 253.342 305.004 253.688 304.773L299.803 278.075C300.265 277.844 300.497 277.381 300.497 276.804V223.524C300.497 222.945 300.265 222.484 299.803 222.252L253.688 195.67C253.226 195.438 252.648 195.438 252.302 195.67L206.187 222.252C205.725 222.483 205.493 223.061 205.493 223.523V276.803C205.493 277.266 205.725 277.843 206.187 278.075L218.785 285.356C225.604 288.823 229.88 284.778 229.88 280.733V228.146C229.88 227.453 230.458 226.759 231.267 226.759H237.161C237.855 226.759 238.548 227.337 238.548 228.146V280.733C238.548 289.863 233.578 295.18 224.91 295.18C222.252 295.18 220.172 295.18 214.277 292.29L202.142 285.356C199.137 283.623 197.288 280.386 197.288 276.919V223.639C197.288 220.172 199.137 216.935 202.142 215.202L248.256 188.504C251.146 186.886 255.076 186.886 257.965 188.504L304.079 215.202C307.084 216.935 308.934 220.172 308.934 223.639V276.919C308.934 280.386 307.084 283.623 304.079 285.356L257.965 312.054C256.462 312.748 254.729 313.094 253.111 313.094H253.11ZM267.326 276.457C247.101 276.457 242.94 267.211 242.94 259.352C242.94 258.658 243.518 257.965 244.327 257.965H250.337C251.03 257.965 251.608 258.427 251.608 259.121C252.533 265.246 255.191 268.251 267.442 268.251C277.15 268.251 281.312 266.055 281.312 260.854C281.312 257.849 280.155 255.654 265.015 254.151C252.417 252.879 244.558 250.106 244.558 240.051C244.558 230.689 252.418 225.141 265.593 225.141C280.386 225.141 287.668 230.227 288.593 241.321C288.593 241.669 288.477 242.015 288.246 242.362C288.014 242.593 287.668 242.824 287.321 242.824H281.311C280.733 242.824 280.155 242.362 280.04 241.784C278.653 235.428 275.07 233.347 265.593 233.347C254.96 233.347 253.688 237.046 253.688 239.819C253.688 243.171 255.191 244.211 269.522 246.06C283.738 247.91 290.442 250.568 290.442 260.507C290.326 270.678 282.005 276.457 267.326 276.457Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.028 104.712C110.028 102.632 108.872 100.666 107.023 99.6258L58.019 71.4258C57.209 70.9628 56.285 70.7318 55.361 70.6158H54.898C53.974 70.6158 53.049 70.9628 52.24 71.4258L3.23596 99.6258C1.38596 100.666 0.230957 102.631 0.230957 104.712L0.346957 180.529C0.346957 181.569 0.924957 182.609 1.84896 183.072C2.77396 183.65 3.92896 183.65 4.73896 183.072L33.864 166.429C35.713 165.389 36.869 163.424 36.869 161.344V125.862C36.869 123.782 38.024 121.817 39.874 120.777L52.24 113.611C53.165 113.033 54.205 112.801 55.245 112.801C56.285 112.801 57.325 113.033 58.135 113.611L70.501 120.777C72.351 121.817 73.506 123.781 73.506 125.862V161.344C73.506 163.424 74.662 165.389 76.511 166.429L105.636 183.072C106.086 183.355 106.607 183.505 107.138 183.505C107.67 183.505 108.191 183.355 108.641 183.072C109.566 182.609 110.144 181.569 110.144 180.529L110.028 104.712ZM345.571 0.346762C344.647 -0.116238 343.491 -0.116238 342.681 0.346762C341.757 0.924762 341.179 1.84876 341.179 2.88876V78.0138C341.179 78.7068 340.833 79.3998 340.139 79.8628C339.446 80.2088 338.752 80.2088 338.059 79.8628L325.808 72.8128C324.91 72.3014 323.894 72.0324 322.86 72.0324C321.827 72.0324 320.811 72.3014 319.913 72.8128L270.909 101.129C269.06 102.169 267.904 104.134 267.904 106.214V162.73C267.904 164.81 269.06 166.776 270.909 167.816L319.913 196.132C320.811 196.643 321.827 196.912 322.86 196.912C323.894 196.912 324.91 196.643 325.808 196.132L374.812 167.816C376.661 166.776 377.817 164.811 377.817 162.73V21.8438C377.817 19.6478 376.661 17.6838 374.812 16.6428L345.572 0.346762H345.571ZM341.064 144.123C341.064 144.701 340.833 145.163 340.37 145.394L323.612 155.102C323.378 155.216 323.121 155.275 322.86 155.275C322.6 155.275 322.343 155.216 322.109 155.102L305.351 145.394C304.888 145.163 304.657 144.585 304.657 144.123V124.706C304.657 124.128 304.888 123.666 305.351 123.435L322.109 113.726C322.343 113.612 322.6 113.552 322.86 113.552C323.121 113.552 323.378 113.612 323.612 113.726L340.37 123.435C340.833 123.665 341.064 124.244 341.064 124.706V144.123ZM508.648 124.244C510.498 123.204 511.538 121.239 511.538 119.158V105.405C511.538 103.325 510.382 101.36 508.648 100.32L459.991 72.1198C459.093 71.6084 458.077 71.3395 457.043 71.3395C456.01 71.3395 454.994 71.6084 454.096 72.1198L405.092 100.435C403.242 101.475 402.087 103.44 402.087 105.52V162.037C402.087 164.117 403.243 166.082 405.092 167.122L453.749 194.86C455.599 195.9 457.795 195.9 459.529 194.86L489 178.45C489.925 177.987 490.503 176.947 490.503 175.907C490.503 174.867 489.925 173.827 489 173.364L439.765 145.048C438.84 144.47 438.262 143.546 438.262 142.506V124.823C438.262 123.783 438.84 122.743 439.765 122.28L455.136 113.496C455.586 113.213 456.107 113.062 456.638 113.062C457.17 113.062 457.691 113.213 458.141 113.496L473.513 122.28C474.438 122.858 475.015 123.782 475.015 124.823V138.692C475.015 139.732 475.593 140.772 476.518 141.234C476.968 141.517 477.489 141.667 478.02 141.667C478.552 141.667 479.073 141.517 479.523 141.234L508.648 124.244V124.244Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M456.292 121.585C456.464 121.471 456.665 121.411 456.87 121.411C457.076 121.411 457.276 121.471 457.448 121.585L466.81 127.017C467.156 127.249 467.387 127.595 467.387 128.057V138.922C467.387 139.384 467.157 139.731 466.81 139.962L457.448 145.394C457.276 145.507 457.076 145.567 456.87 145.567C456.665 145.567 456.464 145.507 456.292 145.394L446.931 139.962C446.584 139.731 446.353 139.384 446.353 138.922V128.058C446.353 127.595 446.583 127.248 446.931 127.018L456.292 121.585V121.585Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240.744 100.435L191.856 72.3509C191.375 72.1084 190.872 71.9147 190.353 71.7729L135.57 165.621C136.024 166.175 136.572 166.645 137.189 167.008L186.077 195.093C187.464 195.902 189.082 196.133 190.584 195.67L242.016 101.592C241.669 101.13 241.206 100.782 240.744 100.436V100.435Z",
    fill: "url(#paint0_linear_141_453)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.459 62.064L183.766 62.411H184.69L184.459 62.064V62.064Z",
    fill: "url(#paint1_linear_141_453)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.891C242.247 166.082 243.287 164.695 243.75 163.193L190.121 71.6569C188.734 71.4259 187.231 71.5409 185.961 72.3499L137.419 100.32L189.774 195.785C190.535 195.66 191.275 195.427 191.97 195.092L240.859 166.892L240.86 166.891Z",
    fill: "url(#paint2_linear_141_453)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.368 165.967L245.021 165.389V166.198L245.367 165.967H245.368Z",
    fill: "url(#paint3_linear_141_453)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.891L192.087 194.976C191.399 195.327 190.656 195.561 189.891 195.669L190.816 197.403L244.905 166.083V165.389L243.518 163.077C243.287 164.695 242.247 166.082 240.86 166.891V166.891Z",
    fill: "url(#paint4_linear_141_453)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.86 166.891L192.087 194.976C191.399 195.327 190.656 195.561 189.891 195.669L190.816 197.403L244.905 166.083V165.389L243.518 163.077C243.287 164.695 242.247 166.082 240.86 166.891V166.891Z",
    fill: "url(#paint5_linear_141_453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_453",
    x1: 181.636,
    y1: 140.256,
    x2: 315.206,
    y2: 67.6872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_141_453",
    x1: 142.983,
    y1: 62.1106,
    x2: 232.996,
    y2: 62.1106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_141_453",
    x1: 132.752,
    y1: 133.665,
    x2: 245.344,
    y2: 133.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_141_453",
    x1: 211.314,
    y1: 165.682,
    x2: 245.118,
    y2: 165.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_141_453",
    x1: 132.753,
    y1: 180.335,
    x2: 245.344,
    y2: 180.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_141_453",
    x1: 261.747,
    y1: 90.6256,
    x2: 233.223,
    y2: 240.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.cd3b7a0c07e4c3dfaf5062c879d702e9.svg";
export { ForwardRef as ReactComponent };